import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../cn";
const sizeToClass = {
    "4xl": "text-4xl max-sm:text-3xl",
    "3xl": "text-3xl max-sm:text-2xl",
    "2xl": "text-2xl max-sm:text-xl",
    xl: "text-xl max-sm:text-lg",
    lg: "text-lg max-sm:text-base",
    base: "text-base max-sm:text-md",
    md: "text-md max-sm:text-sm",
    sm: "text-sm max-sm:text-xs",
    xs: "text-xs",
    inherit: "",
};
/**
 * Use this for rendering text consistently.
 */
export const Txt = forwardRef(function Txt({ size = "base", as, children, className, weight = "normal", color = "primary", align = "left", font = "text", id, ...props }, ref) {
    const As = as || "span";
    return (_jsx(As, { ...props, ref: ref, id: id, className: cn(font === "text" && "font-text", font === "title" && "font-title", font === "mono" && "font-mono", weight === "normal" && "font-normal", weight === "semibold" && "font-semibold", weight === "medium" && "font-medium", align === "left" && "text-left", align === "center" && "text-center", align === "right" && "text-right", color === "primary" && "text-primary", color === "secondary" && "text-secondary", color === "tertiary" && "text-tertiary", color === "inherit" && "text-inherit", sizeToClass[size], className), children: children }));
});
